import axiosPost from "./axiosPost";

export const MerchantBOBPIns= async (credentials, data) => {
    const body = {
        service: "MerchantBOBPIns",
        params: {
            merchantId: data.merchantId,
            merchantBeneficiarioNroDocumento: data.documento,
            merchantBeneficiarioEsDirecto: data.participacionIndirecta,
            merchantBeneficiarioParticipacion: data.porcentaje,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}